import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';

const avatarSX = {
  width: 36,
  height: 36,
  fontSize: '1rem'
};

const actionSX = {
  mt: '6px',
  ml: 1,
  top: 'auto',
  right: 'auto',
  alignSelf: 'flex-start',
  transform: 'none'
};

function getNotificationIcon(iconKey) {
  if (iconKey === 'success') {
    return <CheckCircleOutlined />;
  }

  if (iconKey === 'warning') {
    return <ExclamationCircleOutlined />;
  }

  return <MessageOutlined />;
}

export default function NotificationList({ notifications, onItemClick }) {
  return (
    <List
      component="nav"
      sx={{
        p: 0,
        '& .MuiListItemButton-root': {
          py: 0.5,
          px: 2,
          '&.Mui-selected': { bgcolor: 'grey.50', color: 'text.primary' },
          '& .MuiAvatar-root': avatarSX,
          '& .MuiListItemSecondaryAction-root': { ...actionSX, position: 'relative' }
        }
      }}
    >
      {notifications.map((notification) => (
        <ListItem
          key={notification.id}
          component={ListItemButton}
          divider
          selected={Boolean(notification.isUnread)}
          onClick={() => onItemClick?.(notification)}
          secondaryAction={
            <Typography variant="caption" noWrap>
              {notification.timeLabel}
            </Typography>
          }
        >
          <ListItemAvatar>
            <Avatar sx={{ color: notification.color, bgcolor: notification.backgroundColor }}>{getNotificationIcon(notification.iconKey)}</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={<Typography variant="h6">{notification.title}</Typography>}
            secondary={
              <>
                <Typography variant="body2" color="text.secondary">
                  {notification.message}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {notification.secondary}
                </Typography>
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  );
}
